import Vue from 'vue'
import VueRouter from 'vue-router'
import modules from './modules'
import store from '@/store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    routes: [...modules]//路由表
})

//全局路由前置守卫
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.requireAuth && !store.getters.isLoggedIn) {
        next({
            name: 'login'
        })
    } else {
        next()
    }
})

export default router
